import React from 'react';
import StepCollapsed from 'src/components/Shared/StepCollapsed/StepCollapsed';
import styles from './summary.module.scss';

export interface AutoExchangeSummaryProps {
  className: string;
  handleEditClick: React.MouseEventHandler;
  id: string;
}

export const AutoExchangeSummary: React.FC<AutoExchangeSummaryProps> = ({
  children,
  className,
  handleEditClick,
  id,
}) => {
  return (
    <StepCollapsed className={className}>
      {children}
      <a className={styles['link']} id={id} onClick={handleEditClick}>
        Edit
      </a>
    </StepCollapsed>
  );
};
